// index.ts

let SupportRequestsPendingScreen: React.ComponentType<any>;

if (__PLATFORM__ === '.web') {
  SupportRequestsPendingScreen = require('./SupportRequestsPending.Screen.web').default;
} else {
  SupportRequestsPendingScreen =
    require('./SupportRequestsPending.Screen.native').default;
}

console.log('===PLATFORM===', __PLATFORM__);
export default SupportRequestsPendingScreen;
